import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import { useTenantUserRestoreMutation } from "@/v2-backoffice-client/tenant/user/restore/tenant.user.restore.mutation"

export type TenantUserRestoreMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  tenantId: number
  userId: number
  userName?: string
  onCompleted?(): void
}

function TenantUserRestoreMenuItem(props: TenantUserRestoreMenuItemProps) {
  const { tenantId, userId, userName, onCompleted, ...menuItemProps } = props

  const [restoreTenantUser, { loading, error }] = useTenantUserRestoreMutation({
    onCompleted,
  })

  return (
    <ActionMenu.ConfirmItem
      iconSrc="undo-alt"
      variant="success"
      isLoading={loading}
      error={error}
      errorTitle="Failed to restore user to team"
      confirmTitle="Restore to Team"
      confirmDescription={
        userName
          ? `Are you sure you want to restore ${userName} to this team?`
          : "Are you sure you want to restore this user to the team?"
      }
      confirmText="Restore"
      confirmVariant="success"
      onConfirm={async () => {
        await restoreTenantUser({ variables: { tenantId, userId } })
      }}
      {...menuItemProps}
    >
      Restore to Team
    </ActionMenu.ConfirmItem>
  )
}

export default TenantUserRestoreMenuItem
